import React from 'react';
import Loader from '@minecraft.loader';
import { LoaderWrap, StyledLoadingNotes, StyledLoadingNote } from 'styles/Shared';

type Props = {
  loadingNotes?: string[];
};

const FullLoader = ({ loadingNotes }: Props): JSX.Element => {
  return (
    <LoaderWrap $whiteBackground={!!loadingNotes}>
      <Loader />
      {!!loadingNotes && !!loadingNotes.length && (
        <StyledLoadingNotes>
          {loadingNotes.map((note, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <StyledLoadingNote key={index + 1}>{note}</StyledLoadingNote>
          ))}
        </StyledLoadingNotes>
      )}
    </LoaderWrap>
  );
};

export default FullLoader;
